import React from 'react';
import {
    List, Datagrid, TextField, EditButton,
    Edit, SimpleForm, TextInput, Create, SelectInput
} from 'react-admin';

export const TemplateList = props => (
    <List {...props}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="channel" />
            <TextField source="language" />
            <EditButton />
        </Datagrid>
    </List>
);

export const TemplateEdit = props => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput disabled source="id" sx={{ width: '50%' }} />
            <TextInput source="name" sx={{ width: '50%' }} />
            <TextInput source="channel" sx={{ width: '50%' }} />
            <TextInput source="language" sx={{ width: '50%' }} />
            <TextInput source="subject" sx={{ width: '50%' }} />
            <TextInput source="body" label="Body" multiline rows={12} fullWidth />
        </SimpleForm>
    </Edit>
);

export const TemplateCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="name" sx={{ width: '50%' }} />
            <SelectInput
                source="channel"
                choices={[
                    { id: 'email', name: 'Email' },
                    { id: 'sms',   name: 'SMS'   },
                ]}
                sx={{ width: '50%' }}
            />
            <SelectInput
                source="language"
                choices={[
                    { id: 'en', name: 'English' },
                    { id: 'pl', name: 'Polski'  },
                    // …add more as needed…
                ]}
                sx={{ width: '50%' }}
            />
            <TextInput source="subject" sx={{ width: '50%' }} />
            <TextInput source="body" label="Body" multiline rows={12} fullWidth />
        </SimpleForm>
    </Create>
);